<script setup lang="ts">
import { computed, provide, ref } from "vue";
import { AnnuitiesPremium } from "@/entities/premium";
import { sortedPremiums } from "@/utils/quote";
import { PaymentFrequency } from "@/stores/pensionOptions";
import Premium from "./Premium/Premium.vue";
import { resultPremiumsKey } from "@/components/keys";

const props = defineProps<{
    isExtranetHandoff: boolean;
    premiums: AnnuitiesPremium[];
    paymentFrequency: PaymentFrequency;
    quoteNumber: string;
}>();

defineEmits<{
    (on: "apply", premium: AnnuitiesPremium): void;
}>();

const premiums = computed(() => sortedPremiums(props.premiums));
const activePremium = ref<number | null>(null);
const togglePremium = (premiumId: number) => {
    activePremium.value = activePremium.value === premiumId ? null : premiumId;
};
provide(resultPremiumsKey, {
    activePremium,
    togglePremium,
});
</script>

<template>
    <div
        id="parameters"
        class="col-12 col-lg-9 mt-1"
    >
        <div id="results">
            <div
                v-if="isExtranetHandoff"
                class="row"
            >
                <div
                    id="quote-pack-message"
                    class="col-lg-12 text-center h5 blue p-2"
                >
                    <p>
                        <small>
                            Continue with any provider to see the option to generate quote pack
                        </small>
                    </p>
                </div>
            </div>
            <div id="accordion">
                <div class="row">
                    <template
                        v-for="premium in premiums"
                        :key="`${premium.premiumId}-${premium.company.slug}`"
                    >
                        <Premium
                            :premium="premium"
                            :payment-frequency="paymentFrequency"
                            :quote-number="quoteNumber"
                            @apply="$emit('apply', premium)"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
